import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";

const colors = {
    wrapBgColor: "#373948",
    whiteColor: "#fff",
    subTitleColor: "#F0F1F680",
    linkColor: "#212226"
}

export const useStyles = makeStyles<Theme>(() =>
    createStyles({
        bannerWrap: {
            position: "relative",
            display: "flex",
            alignItems: "center",
            padding: "10px 16px 4px 16px",
            color: colors.whiteColor,
            backgroundColor: colors.wrapBgColor,
            "& p": {
                margin: 0
            },
        },
        textWrap: {
            padding: "0 8px",
            overflow: "hidden"
        },
        bannerTitle: {
            fontSize: "14px",
            lineHeight: "16px",
            fontWeight: 500,
            letterSpacing: "-0.1px"
        },
        bannerSubTitle: {
            fontSize: "12.5px",
            color: colors.subTitleColor,
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            letterSpacing: "-0.3px"
        },
        bannerLink: {
            backgroundColor: colors.whiteColor,
            color: colors.linkColor,
            padding: "6px 12px;",
            borderRadius: "15px",
            fontSize: "15px",
            lineHeight: "18px",
            fontWeight: 600,
            textTransform:"uppercase",
            textDecoration: "none"
        }
    })
)